import { t } from "@lingui/macro";
import * as React from "react";
import { Path, Circle } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const SessionIcon = (props: IconProps) => (
  <Icon
    width="6"
    height="75"
    viewBox="0 0 6 75"
    fill="none"
    title={t`Session`}
    {...props}
  >
    <Circle cx="3" cy="3" r="3" fill="currentColor" />
    <Path
      d="M3 3L3 75"
      stroke="currentColor"
      strokeWidth="2"
      strokeDasharray="4 4"
    />
  </Icon>
);
